// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__1JAZO","buttons":"SendReceipts_buttons__gYBkX","email":"SendReceipts_email__2-Bs4","bookApptTitle":"SendReceipts_bookApptTitle__3PR-7"};